import React, { useEffect, useState } from "react";
import GridPage from "../components/GridPage";
import MainLayout from "../components/MainLayout";
import MainPopup from "../popup-containers/MainPopup";
import PopUpButtons from "../components/PopUpButtons";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import ConfirmBookingPopUp from "../popup-containers/ConfirmBookingPopUp";
import Cancelpopup from "../popup-containers/Cancelpopup";
import { IUDAPI, BindPostAPI } from "../services/APIConnection";
import {
  BookingDetailsHeaders1
} from "../components/HeaderAttribute";
const CancelledBooking = () => {
  const toYMD = (dateStr) => {
    // dateStr format: "DD-MM-YYYY"
    const [dd, mm, yyyy] = dateStr.split("-");
    return `${yyyy}-${mm}-${dd}`;
  };
  const [isLoading, setIsLoading] = useState(false);
  var clientId = sessionStorage.getItem("MstClientId");
  const [bindEnquiryData, setBindEnquiryData] = useState([]);
  const [onSubmit, setOnSubmit] = useState(false);
  const [bindBookingData, setBindBookingData] = useState([]);
  const [bindenquiryChildData, setbindenquiryChildData] = useState([]);
   const [viewPopUp, setViewPopUp] = useState(false);
    const [TxnEnquiryId, setTxnEnquiryId] = useState([]);
    const [countryDropdown, setCountryDropdown] = useState([]);
    const [popUpBookOpen, setpopUpBookOpen] = useState(false);
      const [stateDropdown, setStateDropdown] = useState([]);
    
      const [citydropdown, setCityDropdown] = useState([]);
      const [referralsource, setreferralsource] = useState([]);
       const [lostreasondropdown, setlostreasondropdown] = useState([]);
       const [iddropdown, setiddropdown] = useState([
          { value: "1", label: "Aadhar Card" },
          { value: "2", label: "Voter-ID" },
          { value: "3", label: "Passport Number" },
          { value: "4", label: "Driving License" },
        ]);
         const [roomtype, setroomtype] = useState([]);
          const [paymentType, setPaymentType] = useState([]);
          const [confirm, setConfirmRecord] = useState("");
          const [confirm1, setConfirmRecord1] = useState("");
          const [confirm2, setConfirmRecord2] = useState([]);
  useEffect(() => {
    BindEnquiryrData();
  }, []);

   const [tableData, setTableData] = useState([]);
const [popUpCancelOpen, setpopUpCancelOpen] = useState(false);
 const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [enquirytypedropdown, setenquirydropdown] = useState([]);
   const BindGetEnquiryValues = async () => {
      const data = {
        mstClientId: clientId,
      };
      const response = await BindPostAPI(data, "Enquiry/BindGetEnquiryValues");
      if (response && response.data) {
        const enquiryTypeId = response.data.Table1.map((item) => ({
          value: item.MstEnquiryTypeId,
          label: item.EnquiryType,
        }));
  
        setenquirydropdown(enquiryTypeId);

        
  
        const countryId = response.data.Table2.map((item) => ({
          value: item.MstCountryId,
          label: item.CountryName,
        }));
  
        setCountryDropdown(countryId);


        const cancelid = response.data.Table12.map((item) => ({
          value: item.MstCancellationReasonId,
          label: item.Reason,
        }));
  
        setlostreasondropdown(cancelid);
  
        const stateId = response.data.Table3.map((item) => ({
          value: item.MstStateId,
          label: item.State,
          MstCountryId: item.MstCountryId,
        }));
  
        setStateDropdown(stateId);
  
        const cityId = response.data.Table4.map((item) => ({
          value: item.MstCityId,
          label: item.City,
          MstStateId: item.MstStateId,
        }));
  
        setCityDropdown(cityId);
  
        const idProofId = response.data.Table5.map((item) => ({
          value: item.MstIdProofId,
          label: item.IdProof,
        }));
  
        setiddropdown(idProofId);
  
        const referralsourceid = response.data.Table6.map((item) => ({
          value: item.MstReferralSourceId,
          label: item.ReferralSource,
        }));
        setreferralsource(referralsourceid);
  
        const RoomTypeid = response.data.Table7.map((item) => ({
          value: item.MstRoomtypeId,
          label: item.RoomType,
        }));
        setroomtype(RoomTypeid);
        
        const PaymentTypeId = response.data.Table10.map((item) => ({
          value: item.MstPaymentTypeId,
          label: item.PaymentTypeId,
        }));
        setPaymentType(PaymentTypeId);
        //setTableData(RoomTypeid.length)
      } else {
        setBindEnquiryData([]);
      }
    };

      useEffect(() => {
        BindGetEnquiryValues();
      }, []);
  
  const BindEnquiryrData = async () => {
    setIsLoading(true);
    const data = {
      mstClientId: clientId,
    };

    const response = await BindPostAPI(data, "Enquiry/BindEnquiry");
    if (response && response.data) {
      const filterEnquiryData = response.data.Table.filter(
        // (item) => item.MstEnquiryStatusId === 1 || item.MstEnquiryStatusId === 3
        (item) => item.MstEnquiryStatusId === 1 || item.MstEnquiryStatusId === 2
      );
      setBindEnquiryData(filterEnquiryData);
      // setBindEnquiryData(response.data.Table);
      setbindenquiryChildData(response.data.Table1);
      const filteredRecords = response.data.Table.filter(
        item => item.BookingDeletedBy === null
      );

      const filteredRecords1 = filteredRecords.filter(
        (item) =>
          item.MstEnquiryStatusId !== null && item.MstEnquiryStatusId === 5
      );
      // const filteredRecords1 = response.data.Table.filter(
      //   (item) => item.BookingNo !== null && item.BookingStatus < 5
      // );

      setBindBookingData(filteredRecords);
      setBindBookingData(filteredRecords1);
      setOnSubmit(false);
    } else {
      setBindEnquiryData([]);
      setbindenquiryChildData([]);
    }
    setIsLoading(false);
  };

  // const onViewBooking = (index, flag) => {
  //   console.log("View cancelled booking:", cancelledData[index]);
  //   // open popup or navigate to view page
  // };

    const onViewEnquiry = (rowIndex, flag) => {
      
      onCancelEnquiry(rowIndex, flag);
      
      setpopUpBookOpen(true);
    };
    const onCancelEnquiry = async (rowIndex, flag) => {
      setpopUpBookOpen(true);
      setViewPopUp(true);
      const value = bindBookingData[rowIndex];
      const txnEnquiryId = value.TxnEnquiryId;
      setTxnEnquiryId(txnEnquiryId)
      const drpdetailsData = [
        countryDropdown,
        
        stateDropdown,
        referralsource,
        iddropdown,
        roomtype,
        paymentType,
        citydropdown,
        lostreasondropdown,
      ];
      setConfirmRecord1(drpdetailsData);
  
      // Step 1: Filter child records for this enquiry
      const filtered = Object.values(bindenquiryChildData).filter(
        (item) => String(item.TxnEnquiryId) === String(txnEnquiryId)
      );
  
      // Step 2: Grouping to get unique RoomType
      const groupedTable = {};
      filtered.forEach((item) => {
        const key = item.MstRoomTypeId || item.RoomType;
        if (!groupedTable[key]) {
          groupedTable[key] = item;
        }
      });
  
      // Step 3: Create base roomTableDetailsData with everything from enquiry child
      const roomTableDetailsData = Object.values(groupedTable)
        .filter((item) => item.BookingNoOfRequiredRooms > 0)
        .map((item) => ({
          RoomTypeId: item.MstRoomTypeId,
          RoomType: item.RoomType,
          RoomId: item.RoomId,
          AvailableRoomsId: item.SelectedRoomIds, // will be fetched
          AvailableRoomsName: "",
          AvailableRooms: item.BookingNoOfAvailableRooms, // will be fetched
          Numberofrooms: item.BookingNoOfRequiredRooms,
          numberofadults: item.BookingNoOfAdults,
          numberofchildren: item.BookingNoOfChildren,
          Tariff: item.BookingBasicTariff,
          specialtariff: item.BookingSpecialTariff,
          amount: item.BookingAmount * item.BookingNoOfRequiredRooms,
          Photo: item.Photo,
          Size: item.Size,
          MaxOccupancy: item.MaxOccupancy,
          Bedrooms: item.Bedrooms,
          Balcony: item.Balcony,
          LivingRoom: item.LivingRoom,
          SpaceDetails: item.SpaceDetails,
          AmenitiesDetails: item.AmenitiesDetails,
        }));
  
      // Step 4: Show popup now, will fill data next
      //  handleDeleteRow(0);
      setConfirmRecord2([]);
      setConfirmRecord2(roomTableDetailsData); // temporary without availableRooms
      // setTableData(roomTableDetailsData); // temporary without availableRooms
  
      // Step 5: Add AvailableRoomsId and AvailableRooms to each row
      const fromDate = toYMD(value.BookFrom); // "2025-08-01"; // or use dynamic: toYMD(value.BookFrom)
      const toDate = toYMD(value.BookTo); //"2025-08-05"; // or use dynamic: toYMD(value.BookTo)
     
      for (let i = 0; i < roomTableDetailsData.length; i++) {
        const row = roomTableDetailsData[i];
        if (!row.RoomTypeId) continue;
  
        try {
          const postData = {
            mstRoomTypeId: row.RoomTypeId,
            fromDate: fromDate,
            toDate: toDate,
            mstClientId: clientId,
          };
  
          const response = await BindPostAPI(
            postData,
            "Enquiry/BindGetRoomDetails"
          );
          const apiRow = response?.data?.Table?.[0];
  
          if (apiRow) {
            //  row.AvailableRoomsId = apiRow.AvailableRoomsId ?? "";
            row.AvailableRooms = apiRow.AvailableRooms ?? null;
            row.AvailableRoomsName = apiRow.AvailableRoomsName ?? "";
          } else {
            //    row.AvailableRoomsId = "";
            row.AvailableRooms = null;
            row.AvailableRoomsName = "";
          }
        } catch (err) {
          console.error(`RoomTypeId ${row.RoomTypeId} failed:`, err);
          //   row.AvailableRoomsId = "";
          row.AvailableRooms = 0;
          row.AvailableRoomsName = "";
        }
      }
  
      // Step 6: Push final tableData with AvailableRooms
      setTableData([...roomTableDetailsData]);
  
      setConfirmRecord(value);
      setpopUpCancelOpen(true);
      // Only set viewPopUp = true if editing, else false for view-only
      setViewPopUp(true);
};

const cancel = () => {
  setViewPopUp(false);
  setpopUpCancelOpen(false);   
  setpopUpBookOpen(false);    
  BindEnquiryrData();
};


    const onConfirmBooking = async (rowIndex, flag) => {
        
        setViewPopUp(false);
        const value = bindBookingData[rowIndex];
        const txnEnquiryId = value.TxnEnquiryId;
    
        setConfirmRecord(value);
    
        const drpdetailsData = [
          countryDropdown,
          lostreasondropdown,
          stateDropdown,
          referralsource,
          iddropdown,
          villatypedropdown,
          paymentType,
          citydropdown,
        ];
        setConfirmRecord1(drpdetailsData);
    
        // Step 1: Filter child records for this enquiry
        const filtered = Object.values(bindenquiryChildData).filter(
          (item) => String(item.TxnEnquiryId) === String(txnEnquiryId)
        );
    
        // Step 2: Grouping to get unique RoomType
        const groupedTable = {};
        filtered.forEach((item) => {
          const key = item.MstRoomTypeId || item.RoomType;
          if (!groupedTable[key]) {
            groupedTable[key] = item;
          }
        });
    
        // Step 3: Create base roomTableDetailsData with everything from enquiry child
        const roomTableDetailsData = Object.values(groupedTable).map((item) => ({
          RoomTypeId: item.MstRoomTypeId,
          RoomType: item.RoomType,
          RoomId: item.RoomId,
          AvailableRoomsId: "", // will be fetched
          AvailableRoomsName: "",
          AvailableRooms: item.NoOfAvailableRooms, // will be fetched
          Numberofrooms: item.NoOfRequiredRooms,
          NumberofEnquiryRooms: item.NoOfRequiredRooms,
          numberofadults: item.NoOfAdults,
          numberofchildren: item.NoOfChildren,
          Tariff: item.BasicTariff,
          specialtariff: item.SpecialTariff,
          amount: item.Amount,
          Photo: item.Photo,
          Size: item.Size,
          MaxOccupancy: item.MaxOccupancy,
          Bedrooms: item.Bedrooms,
          Balcony: item.Balcony,
          LivingRoom: item.LivingRoom,
          SpaceDetails: item.SpaceDetails,
          AmenitiesDetails: item.AmenitiesDetails,
        }));
    
        // Step 4: Show popup now, will fill data next
        // handleDeleteRow(0);
        setConfirmRecord2(roomTableDetailsData); // temporary without availableRooms
        setpopUpBookOpen(true);
    
        // Step 5: Add AvailableRoomsId and AvailableRooms to each row
        const fromDate = toYMD(value.BookFrom); // "2025-08-01"; // or use dynamic: toYMD(value.BookFrom)
        const toDate = toYMD(value.BookTo); //"2025-08-05"; // or use dynamic: toYMD(value.BookTo)
    
        for (let i = 0; i < roomTableDetailsData.length; i++) {
          const row = roomTableDetailsData[i];
          if (!row.RoomTypeId) continue;
    
          try {
            const postData = {
              mstRoomTypeId: row.RoomTypeId,
              fromDate: fromDate,
              toDate: toDate,
              mstClientId: clientId,
            };
    
            const response = await BindPostAPI(
              postData,
              "Enquiry/BindGetRoomDetails"
            );
            const apiRow = response?.data?.Table?.[0];
    
            if (apiRow) {
              row.AvailableRoomsId = apiRow.AvailableRoomsId ?? "";
              row.AvailableRooms = apiRow.AvailableRooms ?? null;
              row.AvailableRoomsName = apiRow.AvailableRoomsName ?? "";
            } else {
              row.AvailableRoomsId = "";
              row.AvailableRooms = null;
            }
          } catch (err) {
            console.error(`RoomTypeId ${row.RoomTypeId} failed:`, err);
            row.AvailableRoomsId = "";
            row.AvailableRooms = null;
          }
        }
    
        // Step 6: Push final tableData with AvailableRooms
        setTableData([...roomTableDetailsData]);
      };
      const [villatypedropdown, setvillatypedropdown] = useState([
        { value: "1", label: "1BHK-AC" },
        { value: "2", label: "2BHK-AC " },
        { value: "3", label: "2BHK-Non-AC" },
      ]);

  return (
    <MainLayout pageName={"3"}>
      <div className="p-2">
        <h2 className="text-lg font-semibold mb-3">Cancelled Bookings</h2>

        <GridPage
          title="Cancelled Booking Records"
          header={BookingDetailsHeaders1}   
          records={bindBookingData}
          isLoading={isLoading}
          showAdd={false}
          addbtnView={false}
          onLostEnquiry={onCancelEnquiry}              
         
        />
 {/* <MainPopup
         popUpOpen={popUpBookOpen}
         setpopUpOpen={setpopUpBookOpen}
         Open={onConfirmBooking}
       >
         <div>
           <PopUpScreenTitle
             title=
             "Booking Confirmation"
             
             setpopUpOpen={setpopUpBookOpen}
             hederDetails={setpopUpBookOpen}
           />
           <ConfirmBookingPopUp
             data={confirm}
             data1={confirm1}
             data2={tableData}
             data3={confirm2}
             isOpen={setpopUpBookOpen}
             isSubmit={setOnSubmit}
             viewPopUp={viewPopUp}
           />
         </div>
       </MainPopup> */}

          <MainPopup
               popUpOpen={popUpCancelOpen}
               setpopUpOpen={setpopUpCancelOpen}
               Open={onCancelEnquiry}
             >
               <div>
                 <PopUpScreenTitle
                    hederDetails={true}
                   title="Cancelled Bookings"
       
       
       
                   setpopUpOpen={setpopUpCancelOpen}
                   headerDetails={setpopUpCancelOpen}
                   deleteDetails={deleteDetails}
                   viewDetails={viewDetails}
                 />
                 <Cancelpopup
                   data={confirm}
                   data1={confirm1}
                   data2={tableData}
                   data3={confirm2}
                   isOpen={setpopUpCancelOpen}
                   isSubmit={setOnSubmit}
                   viewPopUp={viewPopUp}
                 />
               </div>
               {
                 <PopUpButtons
                  //  rowIndex={rowIndex}
                  //  handleSubmit={handleSubmit}
                  //  deleteDetails={deleteDetails}
                   cancel={cancel}
                  //  cancelBtn={viewPopUp ? false : true}
                  //  disabledBtn={submitBtnDisabled ? true : false}
                 />
               }
             </MainPopup>

      </div>
        
            
    </MainLayout>
  );
};

export default CancelledBooking;